export const ONE_GB_IN_BYTES = 1024 ** 3;
